import React from "react";
import classNames from "classnames";
import Panel from "./Panel";

interface SectionProps {
  className?: string
}

const Section = (props: React.PropsWithChildren<SectionProps>) => {
  const classes = classNames("section-panel-wrapper", props.className);

  return <section className={classes}>
    {props.children}
  </section>
}

interface SectionPanels {
  Section: typeof Section
  Panel: typeof Panel
}

const SectionPanel: SectionPanels = {
  Section,
  Panel
}

export default SectionPanel;